/** Parses `#rgb` or `#rrggbb` (the `#` is optional); anything else gives black. */
export function getRGB(color: string): [number, number, number] {
  try {
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    const fullColor = color.replace(shorthandRegex, (_, r, g, b) => {
      return r + r + g + g + b + b;
    });

    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullColor);
    return result
      ? [
          parseInt(result[1], 16),
          parseInt(result[2], 16),
          parseInt(result[3], 16),
        ]
      : [0, 0, 0];
  } catch {
    return [0, 0, 0];
  }
}
